import { Visibility } from "@/types";
import { Nominal } from "@/types/utils";

/* Categories */
export type CategoryId = Nominal<number, "CategoryId">;
export function CategoryId(value: number): CategoryId {
  return value as CategoryId;
}

export type CategorySlug = Nominal<string, "CategorySlug">;
export function CategorySlug(value: string): CategorySlug {
  return value as CategorySlug;
}

export type CategoryType = "category" | "header";

export type Category = {
  id: CategoryId;
  name: string;
  type: CategoryType;
  publications: number;
  slug: CategorySlug;
  coverArtUrl: string | null;
  subcategories: Subcategory[];
  visibility: Visibility;
};
export type Subcategory = Omit<Category, "subcategories">;

/* Compositions */
export type CompositionId = Nominal<string, "CompositionId">;
export function CompositionId(value: string): CompositionId {
  return value as CompositionId;
}

export type Composition = {
  id: CompositionId;
  instruments: Instrument[];
  object: "composition";
  title: string;
};

/* Instruments */
export type InstrumentId = Nominal<string, "InstrumentId">;
export function InstrumentId(value: string): InstrumentId {
  return value as InstrumentId;
}

export type Instrument = {
  id: InstrumentId;
  links: InstrumentLink[];
};

export type InstrumentLink = {
  rel: "asm";
  url: string;
};

/* Publications */
export type Art = {
  rel: "cover";
  url: string;
};

export type Difficulty = "introductory" | "beginner" | "intermediate" | "advanced";

export type PublicationId = Nominal<string, "PublicationId">;
export function PublicationId(value: string): PublicationId {
  return value as PublicationId;
}

export type Publication = {
  art: Art[];
  catalog: string;
  catalogRefId: string;
  compositions: Composition[];
  difficulties: Difficulty[];
  id: PublicationId;
  object: "publication";
  title: string;
};

export type PublicationSummary = Omit<Publication, "compositions" | "object"> & {
  compositions: number;
  object: "publication-summary";
};
